import React from 'react'
import { Carousel, Button, } from 'antd';
import classNames from 'classnames';
import { } from '@ant-design/icons';
import style from "./index.less"


class pageOne extends React.Component {
    constructor(props) {
        super(props)
        this.state = {

        }

    }

    //进入注册页
    toRegister() {
        // this.props.history.push("/register");
    }


    render() {
        return (
            // <h1 style={{ paddingTop: '60px' }}>1</h1>
            <div className={style.pageOne_container}>
                <div className={style.pageOne_carousel}>
                    <Carousel
                        autoplay
                        dotPosition='bottom'>
                        <div className={classNames(style['carousel-one'])}>
                        </div>
                        {/* <div className={classNames(style['carousel-two'])}>
                        </div>
                        <div className={classNames(style['carousel-three'])}>
                        </div> */}
                    </Carousel>
                </div>
                <div className={style.pageOne_title}>
                    <div className={style.title_fontOne}>
                        华苏—站式AI开发平台
                    </div>
                    <div className={style.title_fontTwo}>
                        零基础快速入门，支持不同应用领域，一站式使用体验
                    </div>
                    {/* <div className={style.title_fontTwo}>
                        丰富的技术领域和算法类型，支持多场景应用
                    </div> */}
                    <div className={style.title_btn} onClick={this.toRegister}>
                        <a href={process.env.common.LoginUrl} target="_blank">
                            <Button type="link">
                                <span>立即使用</span>
                            </Button>
                        </a>
                    </div>
                </div>


            </div>
        )
    }

}

export default pageOne